import { render, staticRenderFns } from "./remindListPhone.vue?vue&type=template&id=ceb3d75a&scoped=true&"
import script from "./remindListPhone.vue?vue&type=script&lang=js&"
export * from "./remindListPhone.vue?vue&type=script&lang=js&"
import style0 from "./remindListPhone.vue?vue&type=style&index=0&id=ceb3d75a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb3d75a",
  null
  
)

export default component.exports